import { CanGraphMessages, TranslationCanGraphMessages } from "../interfaces/canGraphMessages";

const canGraphMessages: TranslationCanGraphMessages = {
  [CanGraphMessages.title]: "Gráfico CAN",
  [CanGraphMessages.vehicle]: "Veículo",
  [CanGraphMessages.day]: "Dia",
  [CanGraphMessages.apply]: "Aplicar",
  [CanGraphMessages.loading]: "Carregando dados da rede CAN…",
  [CanGraphMessages.noDataTitle]: "Selecione um veículo e um dia para visualizar a rede CAN",
  [CanGraphMessages.noDataDescription]: "Apenas comandos ST300STT são consultados (única origem de dados CAN). Preferência por dados em cache; histórico em fallback.",
  [CanGraphMessages.fields]: "Campos",
  [CanGraphMessages.fieldsCanGroup]: "Rede CAN",
  [CanGraphMessages.fieldsTrackerGroup]: "Comparativos do rastreador",
  [CanGraphMessages.selectAll]: "Selecionar todos",
  [CanGraphMessages.clearAll]: "Limpar",
  [CanGraphMessages.zoomIn]: "Aproximar",
  [CanGraphMessages.zoomOut]: "Afastar",
  [CanGraphMessages.resetZoom]: "Restaurar zoom",
  [CanGraphMessages.sourceLabel]: "Origem dos dados",
  [CanGraphMessages.sourceCache]: "Cache (reg_trackers_data_cache)",
  [CanGraphMessages.sourceData]: "Histórico (reg_trackers_data)",
  [CanGraphMessages.sourceTooltipCache]: "Dados não processados (todas as mensagens dos últimos 10 dias)",
  [CanGraphMessages.sourceTooltipData]: "Dados processados (apenas mensagens 'importantes', sem limite de retenção)",
  [CanGraphMessages.pointsCount]: "Pontos",
  [CanGraphMessages.devId]: "IMEI",
  [CanGraphMessages.invalidDateRange]: "Intervalo inválido. Selecione um único dia.",
  [CanGraphMessages.vehicleWithoutHardware]: "Veículo sem rastreador vinculado.",
  [CanGraphMessages.success]: "Dados da rede CAN carregados.",
  [CanGraphMessages.error]: "Erro ao carregar dados da rede CAN.",
  [CanGraphMessages.fieldCanSpd]: "Velocidade CAN (km/h)",
  [CanGraphMessages.fieldCanEngineRpm]: "RPM do motor",
  [CanGraphMessages.fieldCanEngineCoolantTemperature]: "Temp. arrefecimento (°C)",
  [CanGraphMessages.fieldCanFuelLevelSmoothed]: "Nível de combustível",
  [CanGraphMessages.fieldCanFuelConsumption]: "Consumo de combustível",
  [CanGraphMessages.fieldCanTotalFuelUsed]: "Combustível total usado (L)",
  [CanGraphMessages.fieldCanTotalFuelUsedCounted]: "Combustível total (contado) (L)",
  [CanGraphMessages.fieldCanTotalIdleFuelUsed]: "Combustível em marcha lenta (L)",
  [CanGraphMessages.fieldCanTotalEngineHours]: "Horas de motor (h)",
  [CanGraphMessages.fieldCanTotalEngineHoursCounted]: "Horas de motor (contado) (h)",
  [CanGraphMessages.fieldCanTotalDrivingTime]: "Tempo total de direção (h)",
  [CanGraphMessages.fieldCanOdometer]: "Odômetro CAN (m)",
  [CanGraphMessages.fieldCanIgn]: "Ignição CAN (0/1)",
  [CanGraphMessages.fieldCanGcvw]: "Peso bruto combinado (kg)",
  [CanGraphMessages.fieldSpd]: "Velocidade GPS (km/h)",
  [CanGraphMessages.fieldDist]: "Odômetro rastreador (m)",
  [CanGraphMessages.fieldHMeter]: "Horímetro rastreador (min)",
  [CanGraphMessages.fieldPwrVolt]: "Tensão principal (V)"
};

export const messages = canGraphMessages;
